import {ElementDecorator, ViewTranslator} from '../util/view'
import {$} from '../util/view'
import {REQUIRES_FORMS} from '../util/browser'
import form from './form'
import {postTrackingEvent} from '../util/tracking'
import {PublisherPurposesList} from '../service/publisher-purposes-list'

const INFO_SVG = encodeURI('data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBmaWxsPSIjRkZGIiBmaWxsLW9wYWNpdHk9Ii43IiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik04IDBjNC40MjQgMCA4IDMuNTc2IDggOCAwIDQuNDI0LTMuNTc2IDgtOCA4LTQuNDI0IDAtOC0zLjU3Ni04LTggMC00LjQyNCAzLjU3Ni04IDgtOHptMCAyYTEuNSAxLjUgMCAxIDAgMCAzIDEuNSAxLjUgMCAwIDAgMC0zek02IDZsMSAxdjZINnYxaDR2LTFIOVY2SDZ6Ii8+PC9zdmc+')

export interface Options {
  baseURL: string
  onAccept: EventListener | EventListener[]
  onOpenSettings: EventListener | EventListener[]
  publisherPurposesList: PublisherPurposesList
}

export type Banner = (options: Options) => ElementDecorator

export const defaultBanner: Banner = ({
  baseURL,
  onAccept,
  onOpenSettings,
  publisherPurposesList
}) => {

  return form({
    attributes: {class: 'mol-ads-cmp--banner'},
    baseURL,
    children: (
      $('div', {class: 'mol-ads-cmp--container'}, [
        $('h2', {class: 'mol-ads-cmp--title'}, [
          'DMG Media and its partners use cookies and other technologies to collect user data ',
          $('span', {class: 'mol-ads-cmp--tooltip'}, [
            $('a', {class: 'mol-ads-cmp--tooltip-trigger', href: '#types-of-data-tooltip'},
              $('img', {class: 'mol-ads-cmp--info', src: INFO_SVG})
            ),
            $('div', {id: 'types-of-data-tooltip', class: 'mol-ads-cmp--tooltipcontent'},
              $('div', {class: 'mol-ads-cmp--tooltipframe'}, [
                $('a', {class: 'mol-ads-cmp--tooltip-close', href: '#close'}),
                $('span', {class: 'mol-ads-cmp--tooltipcontent-header'}, 'Types of data being accessed'),
                $('ul', {class: 'mol-ads-cmp--settings-purposes'}, [
                  $('li', {class: 'mol-ads-cmp--settings-purpose'}, 'Unique identifiers for the device using the site'),
                  $('li', {class: 'mol-ads-cmp--settings-purpose'}, 'Browser information'),
                  $('li', {class: 'mol-ads-cmp--settings-purpose'}, 'IP address'),
                  $('li', {class: 'mol-ads-cmp--settings-purpose'}, 'Activities such as pages visited'),
                  $('li', {class: 'mol-ads-cmp--settings-purpose'}, 'Location of where the site is used')
                ])
              ])
            ),
          ]),
          ' from your device, so that:'
        ]),
        $('ul', {class: 'mol-ads-cmp--publisher-purposes'}, [
          $('li', {}, [
            'We can deliver content and advertising that\'s relevant to you ',
            $('div', {class: 'mol-ads-cmp--tooltip'}, [
              $('a', {class: 'mol-ads-cmp--tooltip-trigger', href: '#advertising-purposes-tooltip'},
                $('img', {class: 'mol-ads-cmp--info', src: INFO_SVG}),
              ),
              $('span', {id: 'advertising-purposes-tooltip', class: 'mol-ads-cmp--tooltipcontent'},
                $('div', {class: 'mol-ads-cmp--tooltipframe'},
                  $('div', {}, [
                    $('a', {class: 'mol-ads-cmp--tooltip-close', href: '#close'}),
                    $('span', {class: 'mol-ads-cmp--tooltipcontent-header'}, 'Ways in which we use your data for advertising purposes'),
                    $('ul', {class: 'mol-ads-cmp--settings-purposes'}, [
                      $('li', {class: 'mol-ads-cmp--settings-purpose'}, 'Information storage and access'),
                      $('li', {class: 'mol-ads-cmp--settings-purpose'}, 'Personalisation'),
                      $('li', {class: 'mol-ads-cmp--settings-purpose'}, 'Ad selection, delivery, reporting'),
                      $('li', {class: 'mol-ads-cmp--settings-purpose'}, 'Content selection, delivery, reporting'),
                      $('li', {class: 'mol-ads-cmp--settings-purpose'}, 'Measurement')
                    ])
                  ])
                )
              )
            ]),
          ]),
          $('li', {}, 'We give you the best experience'),
        ]),
        $('div', {class: 'mol-ads-cmp--button-privacy-link-group'}, [
          $('div', {class: 'mol-ads-cmp--message'}, [
            $('div', {}, 'Control how your data is used and view more info at any'),
            $('div', {}, 'time via your Cookie Settings in the Privacy Policy'),
          ]),
          $('div', {class: 'mol-ads-cmp--buttons'}, [
            $('button', {class: 'mol-ads-cmp--cookie-settings', type: 'button'}, 'Cookie Settings').click(onOpenSettings),
            (REQUIRES_FORMS
              ? $('button', {class: 'mol-ads-cmp--btn-primary', type: 'submit'}, 'Got it')
              : $('button', {class: 'mol-ads-cmp--btn-primary', type: 'button'}, 'Got it').click(onAccept)
            ).click(() => postTrackingEvent('overlay accepted')),
          ])
          // $('div', {class: 'mol-ads-cmp--message'}, [
          //   $('div', {}, 'Control how your data is used and view more info at any'),
          //   $('div', {}, 'time via your Cookie Settings in the Privacy Policy'),
          // ])
        ])
        // (REQUIRES_FORMS
        //   ? $('button', {class: 'mol-ads-cmp--btn-primary', type: 'submit'}, 'Got it')
        //   : $('button', {class: 'mol-ads-cmp--btn-primary', type: 'button'}, 'Got it').click(onAccept)
        // ).click(() => postTrackingEvent('overlay accepted')),
        // $('span', {class: 'mol-ads-cmp--open-settings', href: '#'}, 'Control how cookies are used, and view more info in our '),
        // $('a', {class: 'mol-ads-cmp--open-settings', href: '#'}, 'Privacy settings and Policy').click(onOpenSettings),
      ])
    ),
    consent: true
  })
}

export const videoBanner: Banner = ({
  baseURL,
  onAccept
}) =>
  form({
    attributes: {class: 'mol-ads-cmp--banner'},
    baseURL,
    children: [
      $('div', {class: 'mol-ads-cmp--container'}, [
        $('h2', {class: 'mol-ads-cmp--title'}, [
          'DMG Media and its partners use cookies and other technologies to collect user data ',
          $('span', {class: 'mol-ads-cmp--tooltip'}, [
            $('a', {class: 'mol-ads-cmp--tooltip-trigger', href: '#types-of-data-tooltip'},
              $('img', {class: 'mol-ads-cmp--info', src: INFO_SVG})
            ),
            $('div', {id: 'types-of-data-tooltip', class: 'mol-ads-cmp--tooltipcontent'},
              $('div', {class: 'mol-ads-cmp--tooltipframe'},
                $('div', {}, [
                  $('a', {class: 'mol-ads-cmp--tooltip-close', href: '#close'}),
                  $('span', {class: 'mol-ads-cmp--tooltipcontent-header'}, 'Types of data being accessed'),
                  $('ul', {class: 'mol-ads-cmp--settings-purposes'}, [
                    $('li', {class: 'mol-ads-cmp--settings-purpose'}, 'Unique identifiers for the device using the site'),
                    $('li', {class: 'mol-ads-cmp--settings-purpose'}, 'Browser information'),
                    $('li', {class: 'mol-ads-cmp--settings-purpose'}, 'IP address'),
                    $('li', {class: 'mol-ads-cmp--settings-purpose'}, 'Activities such as pages visited'),
                    $('li', {class: 'mol-ads-cmp--settings-purpose'}, 'Location of where the site is used')
                  ])
                ])
              )
            ),
          ]),
          ' from your device, so that:'
        ]),
        $('ul', {class: 'mol-ads-cmp--publisher-purposes'}, [
          $('li', {}, [
            'We can deliver content and advertising that\'s relevant to you ',
            $('div', {class: 'mol-ads-cmp--tooltip'}, [
              $('a', {class: 'mol-ads-cmp--tooltip-trigger', href: '#advertising-purposes-tooltip'},
                $('img', {class: 'mol-ads-cmp--info', src: INFO_SVG}),
              ),
              $('span', {id: 'advertising-purposes-tooltip', class: 'mol-ads-cmp--tooltipcontent'},
                $('div', {class: 'mol-ads-cmp--tooltipframe'}, [
                  $('a', {class: 'mol-ads-cmp--tooltip-close', href: '#close'}),
                  $('span', {class: 'mol-ads-cmp--tooltipcontent-header'}, 'Ways in which we use your data for advertising purposes'),
                  $('ul', {class: 'mol-ads-cmp--settings-purposes'}, [
                    $('li', {class: 'mol-ads-cmp--settings-purpose'}, 'Information storage and access'),
                    $('li', {class: 'mol-ads-cmp--settings-purpose'}, 'Personalisation'),
                    $('li', {class: 'mol-ads-cmp--settings-purpose'}, 'Ad selection, delivery, reporting'),
                    $('li', {class: 'mol-ads-cmp--settings-purpose'}, 'Content selection, delivery, reporting'),
                    $('li', {class: 'mol-ads-cmp--settings-purpose'}, 'Measurement')
                  ])
                ])
              )
            ]),
          ]),
          $('li', {}, 'We give you the best experience'),
        ]),
        (REQUIRES_FORMS
          ? $('button', {class: 'mol-ads-cmp--btn-primary', type: 'submit'}, 'Agree, watch the video')
          : $('button', {class: 'mol-ads-cmp--btn-primary', type: 'button'}, 'Agree, watch the video').click(onAccept)
        ).click(() => postTrackingEvent('overlay accepted')),
        $('p', {},
          $('a', {
            class: 'mol-ads-cmp--open-settings',
            href: '/privacy',
            target: '_blank'
          }, 'See our privacy settings and policy')
        )
      ])
    ],
    consent: true
  })
